export default __webpack_public_path__ + "static/media/designRightNavratri.cc183e51.png";